import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Image } from 'lucide-react';

interface LegacyPhotosSectionProps {
  value: any;
  onChange: (value: any) => void;
  mode: "edit" | "view";
}

export function LegacyPhotosSection({ value, onChange, mode }: LegacyPhotosSectionProps) {
  // Renderiza o componente legado de fotos (placeholder)
  // TODO: Implementar ou importar o componente legado real quando necessário
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Image className="h-5 w-5" />
          Fotos (Legado)
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">
          Componente legado de fotos - flag useNewPhotosInRDO está desativada
        </p>
        {/* Aqui seria renderizado o componente original de fotos do RDO.tsx */}
      </CardContent>
    </Card>
  );
}